import type { HeaderCartInfo } from './Header';
import { Button } from '../../../components/button';
import { Badge } from '../../../components/badge';
import { Image } from '../../../components/image';
export const ShoppingCartMenu = ({
    cartInfo,
    onUserCartClick,
}: {
    cartInfo: HeaderCartInfo;
    onUserCartClick: () => void;
}) => {
    return (
        <div>
            <h2 className="pb-4 pt-2 text-base font-bold uppercase">
                Shopping Cart
            </h2>
            <div className="scrollbar-hide max-h-[50vh] overflow-y-auto border-t border-gray-200 py-4">
                {cartInfo.items.map((item) => (
                    <div
                        key={item.id}
                        className="flex h-20 cursor-default items-center gap-x-4 p-2 hover:bg-gray-100"
                    >
                        <div className="h-16 w-16 overflow-hidden rounded-md">
                            <Image
                                src={item.thumbnail.desktop}
                                alt={item.title}
                                fit="contain"
                            />
                        </div>
                        <div className="flex h-full flex-1 flex-col justify-between">
                            <h3 className="line-clamp-2 text-base font-medium">
                                {item.title}
                            </h3>
                            <div className="items-between flex w-full items-center">
                                <p className="flex-1 text-sm text-gray-500">
                                    {item.price}
                                </p>
                                {item.isSample && (
                                    <div className="relative -top-1 w-8">
                                        <Badge
                                            size="centeredCompact"
                                            text="small"
                                            color="secondary"
                                        >
                                            <span className="text-xs text-gray-600">
                                                SAMPLE
                                            </span>
                                        </Badge>
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="min-w-10 text-right font-medium">
                            x{item.quantity}
                        </div>
                    </div>
                ))}
            </div>
            <div className="flex justify-between py-2 font-medium">
                <p>Subtotal</p>
                <p>{cartInfo.itemTotal.ShortFormat}</p>
            </div>
            <div className="flex justify-between py-2 font-medium">
                <Button
                    size="default"
                    layoutMode="fillFlex"
                    onClick={onUserCartClick}
                >
                    Go To Cart
                </Button>
            </div>
        </div>
    );
};
